import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import ApexCharts from "apexcharts";

interface ChartCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  chartId?: string;
}

const ChartCard: React.FC<ChartCardProps> = ({
  title,
  description,
  children,
  chartId,
}) => {
  const handleSavePng = async () => {
    if (!chartId) return;
    try {
      const { imgURI } = await ApexCharts.exec(chartId, "dataURI");
      const link = document.createElement("a");
      link.href = imgURI;
      link.download = `${chartId}.png`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (e) {
      console.error("Failed to export chart", e);
    }
  };

  return (
    <Card sx={{ height: "100%" }}>
      <CardHeader
        title={title}
        titleTypographyProps={{ fontSize: 16, fontWeight: 800 }}
        subheader={
          description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )
        }
        action={
          chartId && (
            <Tooltip title="Save chart as PNG">
              <IconButton size="small" onClick={handleSavePng}>
                <DownloadOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )
        }
        sx={{ pb: 0, alignItems: "flex-start" }}
      />
      <CardContent sx={{ pt: 1.5 }}>{children}</CardContent>
    </Card>
  );
};

export default ChartCard;
